import { useViewAs } from "@/contexts/ViewAsContext";

const planLabels: Record<string, string> = {
  clarity: "CLARITY (FREE)",
  circle: "OUTSPOKEN CIRCLE",
  advisory_board: "COUNCIL",
};

export default function ViewAsBanner() {
  const { viewAsPlan, isViewingAs, exitViewAs } = useViewAs();

  if (!isViewingAs || !viewAsPlan) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] flex items-center justify-between px-4 md:px-8"
      style={{ height: 36, background: "#E07B00", color: "#fff" }}
    >
      <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase" }}>
        VIEWING AS: {planLabels[viewAsPlan] || viewAsPlan}
      </span>
      <button
        onClick={exitViewAs}
        style={{
          fontSize: 11,
          background: "rgba(0,0,0,0.2)",
          color: "#fff",
          borderRadius: "var(--radius-hairline)",
          padding: "4px 10px",
          border: "none",
          cursor: "pointer",
        }}
      >
        Exit View As
      </button>
    </div>
  );
}
